import { periodColumn } from 'components/columns';
import { BoundStates, CampaignWidget, ClientTitle } from 'components';
import { sepFormat } from 'utilities';
import type { ListCampaign } from 'modules/campaign/campaign/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { CampaignStateTag } from 'modules/campaign/status/CampaignStateTag';

const sumProps = {
  width: 100,
  cellProps: {
    textAlign: 'end' as const,
  },
};

export const columns: ControlledTableColumns<ListCampaign> = [
  flexColumn({
    content: 'Campaign',
    key: 'number',
    required: true,
    cellProps: { className: 'py-1' },
    render: (campaign) => <CampaignWidget {...campaign} link target="_self" />,
    sortable: true,
  }),
  {
    content: 'State',
    width: 90,
    minWidth: 90,
    key: 'sums.state',
    sortable: true,
    render: ({ sums: { state } }) => <CampaignStateTag state={state} appearance="naked" />,
  },
  flexColumn({
    content: 'Client',
    key: 'related_client_title',
    render: (campaign) => <ClientTitle {...campaign} />,
    sortable: true,
  }),
  periodColumn,
  {
    ...sumProps,
    content: 'Income',
    key: 'sums.income_total',
    render: ({ sums: { income_total, state } }) => (state !== 'CANCELED' ? sepFormat(income_total) : null),
    sortable: true,
  },
  {
    ...sumProps,
    content: 'Expense',
    key: 'sums.expense_total',
    render: ({ sums: { expense_total, state } }) => (state !== 'CANCELED' ? sepFormat(expense_total) : null),
    sortable: true,
  },

  {
    ...sumProps,
    content: 'Revenue',
    key: 'sums.revenue',
    sortable: true,
    render: ({ sums: { revenue, state } }) => (state !== 'CANCELED' ? sepFormat(revenue) : null),
  },
  {
    width: 64,
    cellProps: {
      textAlign: 'center',
    },
    key: 'sums',
    configLabel: 'Bound States',
    render: ({ sums }: ListCampaign) => (sums.state !== 'CANCELED' ? <BoundStates {...sums} /> : null),
  },
];
